// Huddle note — the ONLY CC-authored note. Operational pre-visit prep, free text, explicitly NOT
// part of the record. Persisted to huddle_notes (Class-B: field-encrypted at rest, audited,
// doctor-scoped, never in notifications/logs — D5/F01).
import { useEffect, useState } from "react";
import { Btn } from "@championcare/ui";
import { useApi } from "../api";
import { useAsync } from "../lib/useAsync";

export function HuddleNote({ appointmentId }: { appointmentId: string }) {
  const api = useApi();
  const { data, loading } = useAsync(() => api.huddle(appointmentId), [appointmentId]);
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (data?.body) setBody(data.body);
  }, [data]);

  async function save() {
    if (!body.trim()) return;
    setBusy(true);
    try {
      await api.saveHuddle(appointmentId, body.trim());
      setSaved(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="huddle">
      <h4 className="brief__h">Huddle note</h4>
      <p className="muted">Pre-visit prep only — not part of the patient record.</p>
      <textarea
        className="input huddle__text"
        rows={5}
        value={loading ? "" : body}
        placeholder="Notes to prepare for this visit…"
        onChange={(e) => {
          setBody(e.target.value);
          setSaved(false);
        }}
      />
      <div className="card__row">
        <Btn as="button" variant="primary" disabled={busy || !body.trim()} onClick={save}>
          {busy ? "Saving…" : "Save huddle note"}
        </Btn>
        {saved && <span className="muted">Saved.</span>}
      </div>
    </div>
  );
}
